module.exports = __webpack_public_path__ + "img/47ne.4566585c.svg";